<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G4vL2E/tc-custom/9781466817081.jpg?1732132915116" alt="This image is the cover for the book Arshile Gorky"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arshile Gorky
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the Author of <i>Frida</i>, the Moving and Heroic Story of One of the Central Painters of the Twentieth Century</b><br/><br/>Born in Turkey around 1900, Vosdanik Adoian escaped the massacres of Armenians in 1915 only to watch his mother die of starvation and his family scatter in their flight from the Turks. Arriving in America in 1920, Adoian invented the pseudonym Arshile Gorky-and obliterated his past. Claiming to be a distant cousin of the novelist Maxim Gorky, he found work as an art teacher and undertook a program of rigorous study, schooling himself in the modern painters he most admired, especially Cézanne and Picasso. By the early forties, Gorky had entered his most fruitful period and developed the style that is seen as the link between European modernism and American abstract expressionism. His masterpieces influenced the great generation of American painters in the late forties, even as Gorky faced a series of personal catastrophes: a studio fire, cancer, and a car accident that temporarily paralyzed his painting arm. Further demoralized by the dissolution of his seven-year marriage, Gorky hanged himself in 1948.<br/><br/>A sympathetic, sensitive account of artistic and personal triumph as well as tragedy, Hayden Herrera's biography is the first to interpret Gorky's work in depth. The result of more than three decades of scholarship-and a lifelong engagement with Gorky's paintings-<i>Arshile Gorky</i> traces the progress from apprentice to master of the man André Breton called "the most important painter in American history."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hayden Herrera
      </h2>
      
      <p class="authorDescription body article"><P><B>Hayden Herrera</B> is the author of <I>Frida: A Biography of Frida Kahlo, Mary Frank, </I>and <I>Matisse: A Portrait</I>. She lives in New York City.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b1566566